<template>
  <div class="auth">
      <header class="auth__header header">
          <div class="header__container container-fluid">
              <div class="header__hlogo hlogo">
                  <img src="/images/logo-white-rus.svg">
              </div>
          </div>
      </header>

      <div class="auth-page__form auth-form text-center">
          <div class="auth-form__wrap">
              <div class="auth-form__title mb-3">DS Indoor Services</div>
              <div class="auth-form__caption">Сброс пароля</div>
              <div class="auth-form__form-group form-outline ">
                  <input type="email" id="form2Example2" placeholder="Электронная почта" class="form-control form-control-lg" v-model="email" />
              </div>

              <button type="button" class="auth-form__enter btn btn-primary" v-on:click="send()">
                  <span>Продолжить</span>
              </button>
          </div>
      </div>
  </div>
  <Alert />
</template>

<script>
import Alert from '../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
  name: 'ForgotPasswordComponent',
  components: { Alert },
  props: {
      route_password_reset: String,
  },
  data() {
      return {
          email: '',
      }
  },
  methods: {
      ...mapMutations('alerts', ['addAlert']),
      send: async function () {
          if (this.email == '') {
            this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите электронную почту!' })
            return;
          }

          const response = await axios.post(this.route_password_reset, {
              'email': this.email
          }).then((response) => {
              return response.data
          });

          if (response.status == 'ok') {
            this.addAlert({ type: 'success', title: 'Успех', text: response.message })
            window.location.href = '/';
          } else if (response.status == 'error') {
            this.addAlert({ type: 'error', title: 'Ошибка', text: response.message })
          }
      },
  }
}
</script>

<style scoped>

</style>
